import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PopoverController } from '@ionic/angular';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';
import { SelectorFechaComponent } from '../selector-fecha/selector-fecha.component';

export interface Logs_eventos {
  Tipo:string;
  Id:number;
}

@Component({
  selector: 'app-tabla-log-eventos',
  templateUrl: './tabla-log-eventos.component.html',
  styleUrls: ['./tabla-log-eventos.component.scss'],
})
export class TablaLogEventosComponent implements OnInit {
  Fecha1=""
  Fecha2=""
  Logs = []

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  datePipe = new DatePipe("en-US")

  displayedColumns: string[] = ['Nombres', 'Tipo', 'Descripcion', 'IP', 'Fecha'];
  dataSource: MatTableDataSource<Logs_eventos>;
  selection = new SelectionModel<Logs_eventos>(true, []);

  constructor(private conexion: ConexionService, private utilidades: UtilidadesService, private popoverController:
    PopoverController) {
    this.dataSource = new MatTableDataSource([]);
   }

  ngOnInit() {
    this.Fecha2 = this.datePipe.transform(new Date(), "yyyy-MM-dd", "GMT-4")
    this.Fecha1 = this.datePipe.transform(new Date().setMonth(new Date().getMonth() - 3), "yyyy-MM-dd", "GMT-4")
    this.getLogEventos()
  }

    getLogEventos() {
    this.utilidades.Loading("Cargando log de eventos")
    this.conexion.getLogEventos(this.Fecha1, this.Fecha2).subscribe((resp: any) => {
      setTimeout(() => {
        this.utilidades.CerrarLoading()
      }, 200);
      if (resp.Respuesta == "Exito") {
      
        this.Logs = resp.Datos;
        this.dataSource = new MatTableDataSource(resp.Datos);
        this.ngAfterViewInit()
      }
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  async FechaPopover(e: Event, variable: number) {
    let fecha = ""
    if (variable == 1) {
      fecha = this.Fecha1;
    } else {
      fecha = this.Fecha2
    }

    const popover = await this.popoverController.create({
      component: SelectorFechaComponent,
      event: e,
      componentProps: {
        setFecha: fecha
      },
      mode: "md"
    });

    await popover.present();

    popover.onDidDismiss().then(date => {

   if(date.data){
    if (variable == 1) {
      this.Fecha1= this.datePipe.transform(date.data, "yyyy-MM-dd")
  
  } else {
   
      this.Fecha2 =this.datePipe.transform(date.data, "yyyy-MM-dd")
   
  }
   }

    });

  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }
}
